(function () {
  const SELECTOR = ".shopify-section";

  function initReveal() {
    const sections = document.querySelectorAll(SELECTOR);
    if (!sections.length) return;

    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    // Si l’utilisateur préfère réduire les animations, on affiche tout direct
    if (reduceMotion) {
      sections.forEach((s) => s.classList.add("vistillion-reveal", "is-visible"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -10% 0px" }
    );

    sections.forEach((s) => {
      s.classList.add("vistillion-reveal");
      observer.observe(s);
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initReveal);
  } else {
    initReveal();
  }
})();